import React from 'react'

import './QbHeading.css'

const QbHeading = ({ title, text, warning }) => (
  <div className="qb-heading-container">
    <h1>{title}</h1>
    <p>
      <span>{text}</span>
      { warning ?
        <span className="qb-heading-warning-message">&nbsp;<b>Warning:</b> {warning}</span>
      : null }
    </p>
  </div>
)

export default QbHeading


// WEBPACK FOOTER //
// ./src/components/shared/QbHeading/QbHeading.js